import { Chip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BranchAssignmentStatus } from '../single-deal/lib/get-branch-assignment-status';

interface Props {
  status: Exclude<BranchAssignmentStatus, null>;
}

export const BranchStatusChip: FC<Props> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(`branch_assignment.${status}`)}
      sx={{
        bgcolor: '#FFCC00',
        color: '#0B1370',
        fontWeight: 500,
        fontSize: 10,
        height: 20,
        px: 1,
        '& .MuiChip-label': {
          px: 0,
        },
      }}
    />
  );
};
